// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","link":"Lif8F cXdS1 hRgdS"};